import ModalsLib from '../../../../../lib/modals';
import {useSelector, useDispatch} from 'react-redux';
import Selector from '../../../../../selectors/pages/tasks/daily/facebook';
import {showModal} from '../../../../../reducers/modules/actions';
import Diamond from '../../diamond';
import {navigate} from '../../../../../utils/navigation';
import Timer from './timer';

export default () => {
    const {task} = useSelector(Selector),
          dispatch = useDispatch();

    if(task.type === 'hidden')
        return <></>;

    return (
        <div className="task">
            <div className="task-top">
                <div className="icon">
                    <img src={`${window.location.origin}/source/system/tasks/facebook.png`} alt="Facebook Icon" />
                </div>
                <div className="title">Facebook Share</div>
            </div>
            <div className="task-info">
                <div className="descriptions">
                    Share our posts on Facebook to collect diamonds.
                </div>
                {task.type === 'available' ? ( 
                    <div className="button-block">
                        <div className="button" onClick={e => {
                            // ModalsLib.open('facebook_share', {
                            //     post: task.post
                            // });

                            dispatch(showModal('facebook_post'));
                        }}> 
                            Share
                        </div>
                        <div className="diamonds">
                            <Diamond />
                            {task.reward}
                        </div>
                    </div>
                ) : <></>}

                {task.type === 'pending' ? (
                    <div className="button-block pending">
                        Pending
                    </div>
                ) : <></>}

                {task.type === 'timeout' ? (
                    <Timer timestamp={task.timestamp} />
                ) : <></>}
            </div>
        </div>
    )
}